// Smart Group Flow
export const SMART_GROUP_FLOW_SET_INIT = 'SMART_GROUP_FLOW_SET_INIT';
export const SMART_GROUP_FLOW_SET_PROP = 'SMART_GROUP_FLOW_SET_PROP';
export const SMART_GROUP_FLOW_SET_UNSAVED_CHANGES = 'SMART_GROUP_FLOW_SET_UNSAVED_CHANGES';
export const SMART_GROUP_FLOW_SET_NAME_POPUP = 'SMART_GROUP_FLOW_SET_NAME_POPUP';
export const SMART_GROUP_FLOW_SET_QUERY_DATA = 'SMART_GROUP_FLOW_SET_QUERY_DATA';
export const SMART_GROUP_FLOW_SET_DATE_FILTER = 'SMART_GROUP_FLOW_SET_DATE_FILTER';
export const SMART_GROUP_FLOW_CLEAR = 'SMART_GROUP_FLOW_CLEAR';